import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        homeNavValue: '', // 当前在哪个页面
        loading: false
    },
    mutations: {
        changeHomeNavValue (state, stark) {
            state.homeNavValue = stark.name;
        },
        changeLoadingStatus (state,value) {
            state.loading = !state.loading
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/store.js